import React from 'react';
import { Container, Typography, Box, useTheme } from '@mui/material';

const Settings = () => {
  const theme = useTheme();
  
  return (
    <Box sx={{ 
      flexGrow: 1, 
      width: '100%', 
      pt: 8,
      pb: 4,
      backgroundColor: 'rgba(0,0,0,0.9)'
    }}>
      <Container maxWidth="lg">
        <Typography variant="h4" component="h1" gutterBottom>
          Settings
        </Typography>
        {/* Add settings content here */}
      </Container>
    </Box>
  );
};

export default Settings; 